import Vue, { RenderContext } from 'vue';

export const props = {
    footerClass: {
        type: [String, Object, Array],
        default: null
    }
};

export const TCardFooter = Vue.extend({
    name: 'TCardFooter',
    functional: true,
    props,
    render(h: any, { props, children }: RenderContext) {
        return h(
            'div',
            {
                class: [props.footerClass, {}],
                staticClass: 'card-footer'
            },
            children
        );
    }
});
